export default __webpack_public_path__ + "static/media/unselected.cbb4359e.svg";